<template>
  <el-dialog
    title="选择人员"
    :visible.sync="model.show"
    width="20%"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-row :gutter="20">
      <el-col :span="24">
        <el-input
          size="small"
          style="width: 100%"
          placeholder="请输入用户姓名"
          v-model="query.name"
        >
          <template slot="append">
            <el-button
              size="small"
              icon="el-icon-search"
              @click="findUser"
            ></el-button>
          </template>
        </el-input>
      </el-col>
      <el-col :span="24" class="user_list">
        <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%; margin-top: 20px"
          border
          max-height="600"
          @select-all="selectAll"
          @select="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column prop="name" label="名称" align="center">
          </el-table-column>
          <el-table-column prop="phone" label="电话" align="center">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="model.show = false">取 消</el-button>
      <el-button type="primary" @click="returnSelectUser" v-preventReClick>确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      model: {
        show: false,
      },
      selectUser: [],
      list: [],
      query: {
        name: "",
      },
    };
  },
  methods: {
    /* 全选 */
    selectAll(list) {
      this.selectUser = list;
      this.getUserList();
    },
    /* 返回选择人员 */
    returnSelectUser() {
      this.$emit("selectUser", this.selectUser);
      this.model.show = false;
    },
    /* 选择人员 */
    handleSelectionChange(list, row) {
      this.selectUser = list;
    },
    /* 查找人员 */
    findUser() {
      this.getUserList();
    },
    init(list) {
      this.selectUser = [];
      this.selectUser = list;
      this.model.show = true;
      this.getUserList();
    },
    getUserList() {
      this.$http.getRequest("/user/list", this.query).then((res) => {
        if (res.data.code === 200) {
          this.list = res.data.data;
          if (this.selectUser.length != 0) {
            this.list.forEach((e) => {
              this.selectUser.forEach((x) => {
                if (e.id === x.id) {
                  this.$nextTick(() => {
                    this.$refs.multipleTable.toggleRowSelection(e, true);
                  });
                }
              });
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .el-dialog__body {
  padding: 20px !important;
}
.user_list {
}
</style>
